//TODO: Add variable GATSBY_IS_MSW_ON to activate msw on local development
export async function startMSW() {
    const isDev = process.env.NODE_ENV
    const isMswOn = process.env.GATSBY_IS_MSW_ON

    if (isDev && isMswOn) {
        const { worker } = await import('../mocks/browser')

        await worker.start({
            waitUntilReady: true,
        })
    }
}